import axios from '@utils/axios';

const viewProductDetail = {
  state: {
    productVoucherId: 0,
    productTypeId: 0,
    voucherType: 1,
    fromWho: '',
    forWho: '',
    validTo: '',
    code: '',
    redeemed: false
  },
  mutations: {
    setProductVoucherId(state, val) {
      state.moneyVoucherId = val;
    },
    setProductTypeId(state, val) {
      state.productTypeId = val;
    },
    setVoucherType(state, val) {
      state.voucherType = val;
    },
    setFromWho(state, val) {
      state.fromWho = val;
    },
    setForWho(state, val) {
      state.forWho = val;
    },
    setValidTo(state, val) {
      state.validTo = val;
    },
    setCode(state, val) {
      state.code = val;
    },
    setRedeemed(state, val) {
      state.redeemed = val;
    }
  },
  actions: {
    fetchProductVoucher(context) {
      return axios.get('admin/vouchers/getproductvoucher', {
        params: {
          Id: context.state.moneyVoucherId
        }
      }).then((res) => {
        context.commit('setProductTypeId', res.data.result.productTypeId);
        context.commit('setVoucherType', res.data.result.voucherType);
        context.commit('setFromWho', res.data.result.fromWho);
        context.commit('setForWho', res.data.result.forWho);
        context.commit('setValidTo', res.data.result.validTo);
        context.commit('setCode', res.data.result.code);
        context.commit('setRedeemed', res.data.result.redeemed);
      });
    },
    resetContext(context) {
      context.commit('setProductTypeId', 0);
      context.commit('setVoucherType', 1);
      context.commit('setFromWho', '');
      context.commit('setForWho', '');
      context.commit('setValidTo', '');
      context.commit('setCode', '');
      context.commit('setRedeemed', false);
    },
  },
  namespaced: true
};

export default viewProductDetail;
